import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toTitleCase(str: string | undefined | null): string {
  if (!str) return '';
  const lowercased = str.toLowerCase();
  const minorWords = ['de', 'la', 'y', 'en', 'el', 'las', 'los', 'con', 'para', 'por', 'un', 'una', 'unos', 'unas', 'del'];

  return lowercased.split(' ').map((word, index, array) => {
    if (index === 0 || index === array.length - 1) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
    if (minorWords.includes(word)) {
      return word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
}

export function calculateDynamicProgress(completed: number, total: number, minThreshold: number = 100): number {
  if (total <= 0 || completed < minThreshold) return 0;

  const rawPercentage = (completed / total) * 100;

  if (rawPercentage < 1 && rawPercentage > 0) {
    return parseFloat(rawPercentage.toFixed(4));
  }

  return Math.round(rawPercentage);
}


export const getErrorMessage = (error: any, defaultMessage: string = "Error desconocido"): string => {
  if (error && typeof error === 'object') {
    if (error.code) {
      switch (error.code) {
        case '23505': return "Error: Ya existe un registro con este contenido (duplicado).";
        case '23503': return "Error: Referencia no válida o elemento no encontrado (llave foránea).";
        case '42501': return "Error de permisos: No tienes autorización para esta acción (RLS).";
        default: break;
      }
    }
    if (error.message) {
      if (error.message.includes('FetchError') || error.message.includes('Failed to fetch')) {
        return "Error de red: No se pudo conectar al servidor. Revisa tu conexión a internet.";
      }
      if (error.message.includes('timeout')) {
        return "Error: La solicitud tardó demasiado (Timeout). Intenta de nuevo.";
      }
      if (error.message.includes('permission denied') || error.message.includes('RLS') || error.message.includes('row-level security')) {
         return "Error de permisos: No tienes autorización para esta acción.";
      }
      return `Error: ${error.message}`;
    }
  }
  return defaultMessage;
};
